import React, { useState } from "react";
import { ArrowRightIcon, ChevronRightIcon, TargetIcon } from "lucide-react";
import { situations } from "../data/landing";
export function SituationFinder() {
  const [activeId, setActiveId] = useState(situations[0].id);
  const active = situations.find(s => s.id === activeId) ?? situations[0];
  return <section className="section" id="finder" aria-labelledby="finder-heading" data-id="element-159" data-mp="2pf077mv11f5r">
      <div className="shell" data-id="element-160" data-mp="2leg84dqw81gz">
        <div className="section-intro" data-id="element-161" data-mp="2lfrg6prdfvdw">
          <p className="eyebrow" data-id="element-162" data-mp="2gnriz52orgl0">WHERE TO START</p>
          <h2 id="finder-heading" data-id="element-163" data-mp="2glwy1qrezogx">
            Where does communication <span data-id="element-164" data-mp="2bnvfr81tbt6i">break down in your team?</span>
          </h2>
          <p data-id="element-165" data-mp="2bmag540n5k1s">Pick the situation that sounds most familiar to see which practice fits it.</p>
        </div>
        <div className="finder-grid" data-id="element-166" data-mp="26nh5rkgni95u">
          <div className="finder-options" role="group" aria-label="Choose a situation" data-id="element-167" data-mp="21qh03anpr8f9">
            {situations.map(situation => <button key={situation.id} type="button" aria-pressed={situation.id === activeId} onClick={() => setActiveId(situation.id)} data-id="element-168" data-mp="1xpf89ew4lynb">
                {situation.label}
                <ChevronRightIcon size={18} aria-hidden="true" data-id="element-169" data-mp="erdlqjrr563c" />
              </button>)}
          </div>
          <div className="finder-result" aria-live="polite" data-id="element-170" data-mp="jr01p0yyt0fu">
            <p className="eyebrow" data-id="element-171" data-mp="17fj798qmqz48">RECOMMENDED PRACTICE</p>
            <h3 data-id="element-172" data-mp="17g2ffxqha952">{active.title}</h3>
            <p className="finder-workshop" data-id="element-173" data-mp="1cem2y2kpzszj">{active.workshop}</p>
            <p className="finder-desc" data-id="element-174" data-mp="1ce40go7gsij6">{active.description}</p>
            <div className="outcome" data-id="element-175" data-mp="yfmeow14dg3w">
              <TargetIcon size={18} aria-hidden="true" data-id="element-176" data-mp="yel2upca4pl4" />
              <div data-id="element-177" data-mp="12fwsuvz2fctu">
                <strong data-id="element-178" data-mp="12f4zzswurt79">THE PRACTICE FOCUS</strong>
                <p data-id="element-179" data-mp="3j53epbm53mir">{active.outcome}</p>
              </div>
            </div>
            <a className="text-link" href="#workshops" data-id="element-180" data-mp="3j3seflrwkwwe">
              {active.pairWith} <ArrowRightIcon size={15} aria-hidden="true" data-id="element-181" data-mp="3n7givvl8ncdf" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}